import { type LoopPostReturnType } from "lib/db/loops";
import {
  type InferGetServerSidePropsType,
  type NextPage,
  type GetStaticPropsContext,
} from "next";
import Layout from "~/components/Layout";
import { getPostsMetadata, getThumbnail } from "~/lib/db/posts";
import { type ArticlePreviewType } from "~/types";
import { postExcerpt } from "~/utils";
import {
  getMultimediaPostsFromSpecificTerm,
  getSubTermNoId,
} from "~/lib/db/multimedia";
import PlaylistCarouselLayout from "~/components/multimedia/PlaylistCarouselLayout";
import AudioGridLayout from "~/components/multimedia/AudioGridLayout";
import PodcastCarouselLayout from "~/components/multimedia/PodcastCarouselLayout";
import TitleLoop from "~/components/TitleLoop";

const AudioBs: NextPage<InferGetServerSidePropsType<typeof getStaticProps>> = ({
  audioArticle,
  playlistArticle,
  subTermsPodcast,
}) => {
  console.log(playlistArticle);
  return (
    <Layout title="Audio BS">
      <section className="pb-20 pt-0 lg:pb-28 lg:pt-16 print:hidden">
        <div className="w-full">
          <TitleLoop
            titleLoop={"Podcast"}
            customClass={
              "mb-20 lg:mb-32 text-3xl sm:text-4xl text-center font-bold text-black md:text-6xl"
            }
          />
        </div>
        <div className="carousel-wrapper mx-auto max-w-box print:hidden">
          <PodcastCarouselLayout subcategoryToShow={subTermsPodcast} />
        </div>
      </section>

      {playlistArticle.length > 0 && (
        <section className="bg-[#eaebec] py-20 lg:py-28 print:hidden">
          <div className="w-full">
            <TitleLoop
              titleLoop={"Playlist"}
              customClass={
                "mb-20 lg:mb-32 text-3xl sm:text-4xl text-center font-bold text-black md:text-6xl"
              }
            />
          </div>
          <div className="carousel-wrapper print:hidden">
            <PlaylistCarouselLayout articleToShow={playlistArticle} />
          </div>
        </section>
      )}
      <section className="py-20 lg:py-28 print:hidden">
        <div className="w-full">
          <TitleLoop
            titleLoop={"Audio"}
            customClass={
              "mb-20 lg:mb-32 text-3xl sm:text-4xl text-center font-bold text-black md:text-6xl"
            }
          />
        </div>
        <AudioGridLayout articleToShow={audioArticle} />
      </section>
    </Layout>
  );
};

export default AudioBs;

export const getStaticProps = async (_context: GetStaticPropsContext) => {
  const subTermsPodcast = await getSubTermNoId(2921);

  const audioArticle = await getMultimediaPostsFromSpecificTerm("audio");
  const articleIdAudio = audioArticle.map((el) => {
    return el.ID;
  });
  const metaDataAudio =
    articleIdAudio.length > 0 ? await getPostsMetadata(articleIdAudio) : [];
  const thumbnailAudio =
    articleIdAudio.length > 0 ? await getThumbnail(articleIdAudio) : [];

  const playlistArticle = await getMultimediaPostsFromSpecificTerm("playlist");

  const articleIdPlaylist = playlistArticle.map((el) => {
    return el.ID;
  });
  const metaDataPlaylist =
    articleIdPlaylist.length > 0
      ? await getPostsMetadata(articleIdPlaylist)
      : [];
  const thumbnailPlaylist =
    articleIdPlaylist.length > 0 ? await getThumbnail(articleIdPlaylist) : [];

  const mapPostsForClient = (
    posts: LoopPostReturnType[],
    metaData,
    thumbnail
  ): ArticlePreviewType[] =>
    posts.map(
      ({
        ID,
        post_title,
        post_name,
        post_excerpt,
        post_content,
        post_date,
      }) => ({
        post_name,
        post_title,
        post_excerpt:
          post_excerpt != ""
            ? postExcerpt(post_excerpt)
            : postExcerpt(
                post_content
                  ?.replace(/<\/?[^>]+(>|$)/g, "")
                  ?.replace(/\[\/{0,1}et_pb_.*\]/g, "")
              ),
        meta: metaData[Number(ID)] != null ? metaData[Number(ID)] : null,
        thumbnail:
          thumbnail[Number(ID)]?.thumbnail != null
            ? thumbnail[Number(ID)]?.thumbnail
            : null,
        alt:
          thumbnail[Number(ID)]?.alt != null
            ? thumbnail[Number(ID)]?.alt
            : null,
        post_date: post_date.toISOString(),
      })
    );

  return {
    props: {
      audioArticle: mapPostsForClient(
        audioArticle,
        metaDataAudio,
        thumbnailAudio
      ),
      playlistArticle: mapPostsForClient(
        playlistArticle,
        metaDataPlaylist,
        thumbnailPlaylist
      ),
      subTermsPodcast: subTermsPodcast,
    },
  };
};
